import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g fill="#3E414A" fillRule="nonzero">
          <path d="M16.066 13.895v1.447H14.62v2.172h1.447v6.513h2.895v-6.513h1.925l.246-2.172h-2.171v-1.266c0-.586.058-.897.962-.897h1.209V11h-1.94c-2.315 0-3.126 1.086-3.126 2.895z" />
          <path d="M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-.973c9.404 0 17.027-7.623 17.027-17.027S27.404.973 18 .973.973 8.596.973 18 8.596 35.027 18 35.027z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile
